import Header from "components/shared/Header";
import SideBar from "components/shared/SideBar";
import React from "react";

const Layout = ({ children }) => {
  return (
    <div className="flex max-w-screen min-h-screen">
      <div className="hidden md:block">
        <SideBar />
      </div>
      <div className="flex max-h-full min-h-screen flex-1 flex-col ml-0  md:ml-72">
        <Header />
        <div className="w-full">{children}</div>
      </div>
    </div>
  );
};

export default Layout;
